import { updateLocalStorage } from "./local-storage"
import { GTAG_PROPERTIES_KEY } from "./constants";
(async() => {
    //non blocking way of waiting for the gtag function to become available
    while(!window.hasOwnProperty("gtag")){
        await new Promise(resolve => setTimeout(resolve, 100));
    }

    const DEV_ID = 'G-RL9Y26WNW2';
    const STAGE_ID = 'G-HP4KWEP1TM';
    const PROD_ID = 'G-RRP8K4M4F3';

    const ENV_PROD = 'prod';
    const ENV_STAGE = 'stage';
    
    const getId = () => {
      const environment = window.twilio.environment || ENV_DEV;
      switch (environment) {
          case ENV_PROD:
              return PROD_ID;
          case ENV_STAGE:
              return STAGE_ID;
          default:
              return DEV_ID;
      }
    }

    //gtag properties to extract (https://developers.google.com/tag-platform/gtagjs/reference#get)
    const fields = ['gclid','client_id','session_id'];
    const promises = fields.map(field => {
        return new Promise(resolve => {
            gtag('get', getId(), field, resolve);
        });
    })

    Promise.all(promises).then((result)=>{
        let properties = {};
        //map property keys to extracted values
        result.map((value,idx) => {
            if (typeof value === "undefined") value = null;
            properties[fields[idx]] = value;
        })
        //sent extracted properties to segment
        if(typeof analytics !== "undefined"){

            let accountSid = null;
            if (window.twilio.account && window.twilio.account.sid) {
              accountSid = window.twilio.account.sid;
            }
            properties['groupId'] = accountSid;
            //send data to segment
            analytics.page('', '', {}, { properties });   
            updateLocalStorage(GTAG_PROPERTIES_KEY, properties);
        }  
    });
})();




// WEBPACK FOOTER //
// ./src/js/gtag.js